export enum PersonaType {
  ADMIN = 'admin',
  VISITOR = 'visitor',
  MANAGER = 'manager',
  CUSTOMER = 'customer',
}
